import { en as common } from "./common/en.yml";
import { en as booking } from "./booking/en.yml";
import { en as bookingActivity } from "./bookingActivity/en.yml";
import { en as bookingCamp } from "./bookingCamp/en.yml";
import { en as checkIn } from "./checkIn/en.yml";
import { en as hotel } from "./hotel/en.yml";
import { en as hotelWaitingList } from "./hotelWaitingList/en.yml";
import { en as activity } from "./activity/en.yml";
import { en as camp } from "./camp/en.yml";
import { en as user } from "./user/en.yml";

export const buttonEn: any = {
  common: common["buttonCommon"],
  booking: booking["buttonBooking"],
  bookingActivity: bookingActivity["buttonBookingActivity"],
  bookingCamp: bookingCamp["buttonBookingCamp"],
  checkIn: checkIn["buttonCheckIn"],
  hotel: hotel["buttonHotel"],
  hotelWaitingList: hotelWaitingList["buttonHotelWaitingList"],
  activity: activity["buttonActivity"],
  camp: camp["buttonCamp"],
  user: user["buttonUser"],
};
